import { IColumnLayout, IModuleConfig, ISlotConfig } from 'redux-state/layout/types.modules.js';
import { IModuleConfigState, ModuleTypeEnum } from 'redux-state/modules/types.js';
import { AnyObjectType } from 'utilities/helpers/object.scaffold.js';
import { getFirstOfArr } from 'utilities/isType.js';

export type IAdvertHide<T> = T & {
  hideWhen?: IColumnLayout;
  showWhen?: never;
};

export type IAdvertShow<T> = T & {
  showWhen?: IColumnLayout;
  hideWhen?: never;
};

export type NullableAnyObject = AnyObjectType | undefined;

export type IADShowHide<T extends NullableAnyObject = {}> = IAdvertShow<T> | IAdvertHide<T>;

/** If dataurl has hide module then dont display on sidebar */
export const hideHiddenModules = ({ hideModule }: IModuleConfig): boolean => hideModule !== true;

// should item display
export function displayShowWhenHideWhenLabel<T extends NullableAnyObject>(
  config: IADShowHide<T> | undefined,
  columnLayout: IColumnLayout,
): boolean {
  /* Due to back end errors configs can sometimes be misconstructed e.g. {TOWN-BELT}
   * Best place to check that is here and hide if it is to avoid errors */
  // if (predicateObject(config)) {
  if (config?.hideWhen) {
    if (columnLayout === config.hideWhen) {
      return false;
    }
  }
  if (config?.showWhen) {
    if (columnLayout !== config.showWhen) {
      return false;
    }
  }
  return true;
  // }
  // if (config) {
  //   messageLog.error(`Error: Module ${config}`);
  // }
  // return false;
}

export const getSelectedConfig = <T extends NullableAnyObject>(
  configs: Array<IADShowHide<T>>,
  layout: IColumnLayout,
): IADShowHide<T> | undefined => {
  const filteredConfigs = configs.filter((config) => {
    return displayShowWhenHideWhenLabel(config, layout);
  });
  return getFirstOfArr(filteredConfigs);
};

export function filterOutHiddenModules(columnLayout: IColumnLayout, modArr: IModuleConfig[] = []): IModuleConfig[] {
  const modules = modArr.filter(({ layout }) => {
    return displayShowWhenHideWhenLabel(layout, columnLayout);
  });
  return modules;
}

export const getSlot = (slot?: ISlotConfig): ISlotConfig => (!slot?.modules ? { modules: [] } : slot);

export const buildSlot = (slot?: ISlotConfig): ISlotConfig => (!slot?.modules ? { modules: [] } : slot);

export const scaffoldModuleTypes = (modules: IModuleConfig[] = []): IModuleConfigState[] => {
  const newMods = modules.map((m) => {
    if (m.dataUrl) {
      const dynModule: IModuleConfigState = {
        type: { module: ModuleTypeEnum.ModuleDynamic, dynamicUrl: m.dataUrl },
        data: m,
      };
      return dynModule;
    }
    const staticModule: IModuleConfigState = {
      type: { module: ModuleTypeEnum.ModuleStatic },
      data: m,
    };
    return staticModule;
  });
  return newMods;
};
